import React from 'react';

export default class Oops extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
        }
    }

    componentDidMount() {
    }

    render() {
        return (
            <div className="homeContainer">
                <div className="homeWelcomeContent">
                    <div className="container-fluid">
                        <h1>
                            Oops, please log in to access admin pages!
                        </h1>                        
                    </div>
                </div>
            </div>
        )
    }
}